var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t(
        "trigger",
        function () {
          return [
            _c("UiButton", {
              attrs: { buttonText: _vm.defaultButtonText },
              on: { click: _vm.openModal },
            }),
          ]
        },
        { openModal: _vm.openModal }
      ),
      _vm.modalOpened
        ? _c("ModalFullScreen", {
            attrs: { title: _vm.title },
            on: { close: _vm.closeModal },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return [
                      _vm._t("default", null, { closeModal: _vm.closeModal }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }